<template>
  <label :class="['block', wrapperClass]">
    <span v-if="label" class="label">{{ label }}</span>
    <select :value="modelValue" :disabled="disabled" :required="required" class="field" v-bind="selectAttrs" @change="onChange">
      <slot />
    </select>
  </label>
</template>

<script lang="ts">
import { computed, useAttrs } from "vue";

export default {
  inheritAttrs: false,
  props: {
    modelValue: { type: [String, Number, Boolean], default: "" },
    modelModifiers: { type: Object, default: () => ({}) },
    label: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
  },
  emits: ["update:modelValue", "change"],
  setup(props: any, { emit }: any) {
    const attrs = useAttrs();
    const wrapperClass = computed(() => attrs.class);
    const selectAttrs = computed(() => {
      const next = { ...attrs };
      delete next.class;
      return next;
    });
    const onChange = (event: Event) => {
      const target = event.target as HTMLSelectElement;
      emit("update:modelValue", props.modelModifiers.number ? Number(target.value) : target.value);
      emit("change", event);
    };
    return { onChange, wrapperClass, selectAttrs };
  },
};
</script>
